import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import logger from 'src/utils/capacitor/logger';

export const getLatestBundle = async () => {
  const latest = await CapacitorUpdater.getLatest();
  logger.info(`Latest bundle: ${JSON.stringify(latest)}`);

  return latest;
};

export const downloadBundle = async (version: { url: string; version: string }) => {
  return CapacitorUpdater.download({
    url: version.url,
    version: version.version,
  });
};

export const downloadLatestBundle = async () => {
  logger.info('Checking for new bundle...');
  const current = await CapacitorUpdater.current();
  logger.info(`Current bundle: ${JSON.stringify(current)}`);

  const latest = await getLatestBundle();

  if (latest.url) {
    const data = await downloadBundle({
      url: latest.url,
      version: latest.version,
    });

    logger.info(`Download completed: ${JSON.stringify(data)}`);
    return data;
  }

  return null;
};

export const setBundle = async (bundleId: string) => {
  try {
    logger.info(`Setting current bundle to: ${bundleId}`);

    await CapacitorUpdater.set({ id: bundleId });
  } catch (err) {
    logger.info(`Error setting bundle to: ${bundleId}`);
    logger.log(err);
  }
};

export const updateCapgoBundleImmediately = async () => {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }

  try {
    const data = await downloadLatestBundle();

    if (data) {
      await setBundle(data.id);
      return true;
    }
  } catch (e) {
    logger.log(e.toString());
  }
};
